import { render, staticRenderFns } from "./Thanksgiving2025_defaultSection.vue?vue&type=template&id=aee5c450&scoped=true"
import script from "./Thanksgiving2025_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Thanksgiving2025_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Thanksgiving2025_defaultSection.vue?vue&type=style&index=0&id=aee5c450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee5c450",
  null
  
)

export default component.exports